import axios from 'axios';
import { apiServerHost } from '../../common/APIServerSettings';

const deleteEntity = (callBackFunc, errorCallBackFunc, entityUpdateID) => {
  const params = new URLSearchParams();
  params.append('entityID', entityUpdateID);

  axios.post(apiServerHost + "/manage/topic/builder/delete/entity", params)
  .catch(errorCallBackFunc)
  .then(callBackFunc)
}

/**
 * 엔티티 디테일 가져오기
 * @param {Function} callBackFunc 
 * @param {number} entityUpdateID 
 */
const getEntityDetail = (callBackFunc, entityId) => {
  const params = new URLSearchParams();
  params.append('entityId', entityId);

  axios.get(apiServerHost + "/manage/topic/builder/get/entityDetail", {
    params : params,
  })
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

export {deleteEntity};
export {getEntityDetail};
